import { Observable, filter, take } from 'rxjs';

export function emitTruthyOnceAndComplete<T>(
  observable: Observable<T>
): Observable<Exclude<T, null | undefined | false>> {
  return observable.pipe(
    filter((value): value is Exclude<T, null | undefined | false> => {
      return value !== null && value !== undefined && value !== false;
    }),
    take(1)
  );
}
